export const publishPanelKind={
    main:0,
    setFile:1,
    uploadCheck:2,
};